export default __webpack_public_path__ + "static/media/btcp.35b8ab70.svg";